module.exports = __webpack_public_path__ + "static/img/icon-notok.962fd1fb.svg";